import React from 'react';
import FaExternalLink from 'react-icons/lib/fa/external-link';

/**
 * A closed menu box that does not "open". Instead,
 * clicking MenuLink clicks away.
 * @reactProps {string} url - the link
 * @reactProps {string} label - the button label
 */
export default class MenuLink extends React.Component {
  /**
   * Renders
   * @return a div > h3 > a, FaExternalLink
   */
  render() {
    return (
      <div className="closed-menu link">
        <h3>
          <a href={this.props.url} target="_blank" rel="noopener noreferrer">
            {this.props.label}
          </a>{' '}
          <FaExternalLink />
        </h3>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MenuLink.js